
        var result = require("!!../../../../node_modules/css-loader/index.js!./giftcertificate.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/giftcertificate.component.css
// module id = 2349
// module chunks = 1